import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  Autocomplete,
  CircularProgress,
  createFilterOptions,
  Paper,
  InputAdornment,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import { Add, Clear, DeleteOutlined, EditOutlined } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import moment from "moment";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import NormalTable from "../../../Component/NormalTable";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  fromUTC,
  getCurrentInTimeZone,
  getDateWithOutUTC,
  toUTC,
} from "../../../utils/dateUtil";
import { woStatus } from "../../../ConfigInfo/Info";

const IssueModal = ({ mode, handleCloseClick, editData }) => {
  const [woData, setWOData] = useState([]);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [assetData, setAssetData] = useState([]);
  const [partAssignType, setPartAssignType] = useState("Unassigned");
  const [issueItem, setIssueItem] = useState({
    partId: null,
    stockRoomId: null,
    stockRoomRowId: null,
    stockRoomRowAisleId: null,
    stockRoomRowBinId: null,
    quantity: 0,
    unitCost: 0,
    lineCost: 0,
    issuedDate: getCurrentInTimeZone().dayjsObject,
  });
  const [stockRoomOptions, setStockRoomOptions] = useState([]);
  const [stockAisleOptions, setStockAisleOptions] = useState([]);
  const [stockRowOptions, setStockRowOptions] = useState([]);
  const [stockBinOptions, setStockBinOptions] = useState([]);
  const [maxQuantity, setMaxQuantity] = useState("");
  const [maxQuantityLoading, setMaxQuantityLoading] = useState(false);
  const [reservedQuantity, setReservedQuantity] = useState("");

  const [partData, setPartData] = useState([]);
  const [workOrderParts, setWorkOrderParts] = useState([]);
  const [reservedParts, setReservedParts] = useState([]);
  const [loadingParts, setLoadingParts] = useState(false);
  const [personData, setPersonData] = useState([]);

  const [addIssue, setAddIssue] = useState([]);

  const [loading, setLoading] = useState(false);
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    fetchPartall();
    const link = masterAPI["workOrder"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setLoading(false);
        setWOData(res.data.result.filter((wo) => wo.status?.toUpperCase() !== woStatus.CLOSE));
        if (mode === "Edit" && editData.workOrderId) {
          const selWO = res.data.result.find(
            (w) => w.id === editData.workOrderId,
          );
          if (selWO) {
            setSelectedWorkOrder(selWO);
          }
        }
      })
      .catch((e) => {
        setWOData([]);
        setLoading(false);
        console.log(e, "create wo");
      });

    const personLink = masterAPI["person"].link;
    await axiosPrivate
      .get(`${personLink}`)
      .then((res) => {
        setPersonData(res.data.result);
      })
      .catch((e) => {
        setPersonData([]);
        console.log(e, "error");
      });

    const assetlink = masterAPI["assets"].link;
    await axiosPrivate
      .get(`${assetlink}`)
      .then((res) => {
        setLoading(false);
        setAssetData(res.data.result);
      })
      .catch((e) => {
        setLoading(false);
        setAssetData([]);
        console.log(e, "create asset");
      });

    if (mode === "Edit" && editData.id) {
      const issueItemsLink = masterAPI["issue"].issueList;
      await axiosPrivate
        .get(`${issueItemsLink}/${editData.id}`)
        .then((res) => {
          setAddIssue(res.data.result || []);
        })
        .catch((e) => {
          console.log(e, "error fetching issue items");
          setAddIssue([]);
        });
    }
  };
  const fetchPartall = () => {
    const partLink = masterAPI["inventory"].getAll;
    axiosPrivate
      .get(`${partLink}`)
      .then((res) => {
        console.log(res, "partLink");
        const partIdFilt = [];
        const partFilter = [];
        for (let i = 0; res.data.result.length > i; i++) {
          if (!partIdFilt.includes(res.data.result[i].partId)) {
            partIdFilt.push(res.data.result[i].partId);
            partFilter.push(res.data.result[i]);
          }
        }
        console.log(partFilter);
        setPartData(partFilter);
      })
      .catch((e) => {
        setPartData([]);
        console.log(e, "error part Data");
      });
  };

  const fetchWorkOrderParts = async (workOrderId) => {
    setLoadingParts(true);
    setWorkOrderParts([]);

    try {
      const response = await axiosPrivate.get(
        `${masterAPI?.["workOrder"]?.getWOPartByWOId}/${workOrderId}`,
      );

      if (response.data.statusCode === 200) {
        setWorkOrderParts(response.data.result);
      }
    } catch (error) {
      console.log(error, "error fetching work order parts");
      setWorkOrderParts([]);
    } finally {
      setLoadingParts(false);
    }
  };

  const fetchReservedParts = async (workOrderId) => {
    setLoadingParts(true);
    setReservedParts([]);
    try {
      const response = await axiosPrivate.get(
        `${masterAPI.partsReservation.getPartReservationById}/${workOrderId}`,
      );

      if (response.data.statusCode === 200) {
        console.log(response.data.result, "reserved parts response");
        const result = response.data.result;
        const allItems = Array.isArray(result)
          ? result.flatMap((r) => r.partsReservationItemsList || [])
          : result?.partsReservationItemsList || [];
        setReservedParts(allItems);
      }
    } catch (error) {
      console.log(error, "error fetching reserved parts");
      setReservedParts([]);
    } finally {
      setLoadingParts(false);
    }
  };

  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  const initialValue = {
    // id: mode === "Edit" ? editData.id : null,
    workOrderId: mode === "Edit" ? editData.workOrderId : null,
    assetId: mode === "Edit" ? editData.assetId : null,
    issuedToPersonId: mode === "Edit" ? editData.issuedToPersonId : null,
    issuedDate:
      mode === "Edit"
        ? editData.issuedDate !== null && editData.issuedDate !== undefined
          ? fromUTC(editData.issuedDate).dayjsObject
          : getCurrentInTimeZone().dayjsObject
        : getCurrentInTimeZone().dayjsObject,
    glCreditAccount: mode === "Edit" ? editData.glCreditAccount : "",
    glDebitAccount: mode === "Edit" ? editData.glDebitAccount : "",
  };

  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true);
    let postData = {};
    const createLink = masterAPI["issue"].create;
    const updateLink = masterAPI["issue"].update;
    // if (mode === "Create") {
    if (mode === "Edit") {
      postData = {
        id: editData.id,
        ...value,
        issuedItemsList: addIssue,
      };
    } else {
      postData = {
        ...value,
        issuedItemsList: addIssue,
      };
    }
    console.log(postData);
    await axiosPrivate
      .post(`${createLink}`, postData)
      .then((res) => {
        console.log(res.data);
        setLoading(false);
        handleCloseClick();
      })
      .catch((e) => {
        setLoading(false);
        console.log(e, "create Issue");
      });
    // } else {
    //     const updateAC = {
    //         id: editData.id,
    //         ...value,
    //         issuedItemsList: addIssue,
    //     };
    //     await axiosPrivate
    //         .put(`${updateLink}`, updateAC)
    //         .then((res) => {
    //             console.log(res.data);
    //             setLoading(false);
    //             handleCloseClick();
    //         })
    //         .catch((e) => {
    //             setLoading(false);
    //             console.log(e, "update Issue");
    //         });
    // }
  };

  const handlePart = async (value) => {
    const srLink = masterAPI["selectList"].stockRoomByPart;
    await axiosPrivate
      .get(`${srLink}/${value.partId}/true`)
      .then((res) => {
        const storeRI = {
          ...issueItem,
          partId: value.partId,
          code: value.code,
          partName: value.partName,
          stockRoomId: null,
          stockRoomName: "",
          stockRoomRowAisleId: null,
          stockRoomRowId: null,
          stockRoomRowBinId: null,
        };
        setIssueItem(storeRI);
        setStockRoomOptions(res.data);
        setStockAisleOptions([]);
        setStockRowOptions([]);
        setStockBinOptions([]);
        setMaxQuantity("");
        setReservedQuantity("");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleAssignedPart = async (value) => {
    const srLink = masterAPI["selectList"].stockRoomByPart;
    await axiosPrivate
      .get(`${srLink}/${value.partId}`)
      .then((res) => {
        const storeRI = {
          ...issueItem,
          partId: value.partId,
          workOrderPartsId: value.id,
          partCode: value.code || "",
          partName: value.partName,
          stockRoomId: null,
          stockRoomName: "",
          stockRoomRowAisleId: null,
          stockRoomRowId: null,
          stockRoomRowBinId: null,
        };
        setIssueItem(storeRI);
        setStockRoomOptions(res.data);
        setStockAisleOptions([]);
        setStockRowOptions([]);
        setStockBinOptions([]);
        setMaxQuantity("");
        setReservedQuantity("");
      })
      .catch((e) => {
        console.log(e);
        const storeRI = {
          ...issueItem,
          partId: value.partId,
          workOrderPartsId: value.id,
          partCode: value.code || "",
          partName: value.partName,
          stockRoomId: null,
          stockRoomName: "",
          stockRoomRowAisleId: null,
          stockRoomRowId: null,
          stockRoomRowBinId: null,
        };
        setIssueItem(storeRI);
        setStockRoomOptions([]);
        setStockAisleOptions([]);
        setStockRowOptions([]);
        setStockBinOptions([]);
        setMaxQuantity("");
        setReservedQuantity("");
      });
  };

  const handleReservedPart = async (value) => {
    console.log(value, "reserved part", value.partsId);
    const srLink = masterAPI["selectList"].stockRoomByPart;
    await axiosPrivate
      .get(`${srLink}/${value.partsId}/true`)
      .then(async (res) => {
        const storeRI = {
          ...issueItem,
          partId: value.partsId,
          partsReservationId: value.id,
          code: value.partCode || "",
          partName: value.partName,
          stockRoomId: value.stockRoomId,
          stockRoomName: value.stockRoomName,
          stockRoomRowAisleId: null,
          stockRoomRowId: null,
          stockRoomRowBinId: null,
          quantity: value.quantity,
        };
        setIssueItem(storeRI);
        setStockRoomOptions(res.data);
        setStockRowOptions([]);
        setStockBinOptions([]);
        if (value.stockRoomId && value.stockRoomName) {
          console.log(value.partsId);
          const getAisleLink = masterAPI["selectList"].aisleByPartAndRoom;
          await axiosPrivate
            .get(`${getAisleLink}/${value.partsId}/${value.stockRoomId}/true`)
            .then((aisleRes) => {
              setStockAisleOptions(aisleRes.data);
            })
            .catch((e) => {
              console.log(e, "error fetching aisle");
              setStockAisleOptions([]);
            });
        } else {
          setStockAisleOptions([]);
        }
      })
      .catch(async (e) => {
        console.log(e);
        const storeRI = {
          ...issueItem,
          partId: value.partId,
          partsReservationId: value.id,
          partCode: value.partCode || "",
          partName: value.partName,
          stockRoomId: value.stockRoomId,
          stockRoomName: value.stockRoomName,
          stockRoomRowAisleId: null,
          stockRoomRowId: null,
          stockRoomRowBinId: null,
          quantity: value.quantity,
        };
        setIssueItem(storeRI);
        setStockRoomOptions([]);
        setStockRowOptions([]);
        setStockBinOptions([]);
        if (value.stockRoomId && value.stockRoomName) {
          const getAisleLink = masterAPI["selectList"].aisleByPartAndRoom;
          await axiosPrivate
            .get(`${getAisleLink}/${value.partId}/${value.stockRoomId}`)
            .then((aisleRes) => {
              setStockAisleOptions(aisleRes.data);
            })
            .catch((e) => {
              console.log(e, "error fetching aisle");
              setStockAisleOptions([]);
            });
        } else {
          setStockAisleOptions([]);
        }
      });
    // Update Max Quantity + unit price for the reserved stock room
    if (value.stockRoomId) {
      fetchInventoryMax({
        partId: value.partsId || value.partId,
        stockRoomId: value.stockRoomId,
        stockRoomRowAisleId: null,
        stockRoomRowId: null,
        stockRoomRowBinId: null,
      });
    }
  };

  const handleAddIssue = (e) => {
    const { name, value } = e.target;
    if (name === "quantity") {
      // Hard limit: cannot exceed available (Max) quantity
      if (value !== "" && maxQuantity !== "" && Number(value) > Number(maxQuantity)) {
        toast.warn(`Max Qantity ${maxQuantity}`);
        return;
      }
      // Soft warning: Reserved type entering more than the reserved quantity
      if (
        partAssignType === "Reserved" &&
        value !== "" &&
        reservedQuantity !== "" &&
        Number(value) > Number(reservedQuantity)
      ) {
        toast.warn("Reserved quantity limit is exceeded");
      }
      setIssueItem({
        ...issueItem,
        [name]: value,
        lineCost: Number(value) * Number(issueItem.unitCost),
      });
    } else {
      setIssueItem({ ...issueItem, [name]: value });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  const handleWorkOrderChange = (event, value, setFieldValue) => {
    setIssueItem({
      partId: null,
      stockRoomId: null,
      stockRoomRowId: null,
      stockRoomRowAisleId: null,
      stockRoomRowBinId: null,
      quantity: 0,
      unitCost: 0,
      lineCost: 0,
      issuedDate: getCurrentInTimeZone().dayjsObject,
    });
    setStockRoomOptions([]);
    setStockAisleOptions([]);
    setStockRowOptions([]);
    setStockBinOptions([]);
    setAddIssue([]);
    setMaxQuantity("");
    setReservedQuantity("");

    if (value !== null) {
      setFieldValue("workOrderId", value.id);
      setSelectedWorkOrder(value);

      if (partAssignType === "Assigned") {
        fetchWorkOrderParts(value.id);
      } else if (partAssignType === "Reserved") {
        fetchReservedParts(value.id);
      }
    } else {
      setFieldValue("workOrderId", null);
      setSelectedWorkOrder(null);
      setWorkOrderParts([]);
      setReservedParts([]);
    }
  };

  const handlePartAssignTypeChange = (e) => {
    const newType = e.target.value;
    setPartAssignType(newType);

    setIssueItem({
      partId: null,
      stockRoomId: null,
      stockRoomRowId: null,
      stockRoomRowAisleId: null,
      stockRoomRowBinId: null,
      quantity: 0,
      unitCost: 0,
      lineCost: 0,
      issuedDate: getCurrentInTimeZone().dayjsObject,
    });
    setStockRoomOptions([]);
    setStockAisleOptions([]);
    setStockRowOptions([]);
    setStockBinOptions([]);
    setMaxQuantity("");
    setReservedQuantity("");
    // setAddIssue([]);

    if (selectedWorkOrder) {
      if (newType === "Unassigned") {
        fetchPartall();
      } else if (newType === "Reserved") {
        fetchReservedParts(selectedWorkOrder.id);
      }
    }
  };

  // Calls the inventory search for the given location combination
  // (any of stock room / aisle / row / bin) and updates Max Quantity + unit cost.
  // Callers must pass the full current context explicitly (issueItem state
  // updates are async, so partial values can't be merged in here).
  const fetchInventoryMax = async ({
    partId,
    stockRoomId,
    stockRoomRowAisleId: aisleId,
    stockRoomRowId: rowId,
    stockRoomRowBinId: binId,
  }) => {
    if (!partId) return;

    const payload = { partId };
    if (stockRoomId) payload.stockRoomId = stockRoomId;
    if (aisleId) payload.stockRoomAisleId = aisleId;
    if (rowId) payload.stockRoomRowId = rowId;
    if (binId) payload.stockRoomBinId = binId;

    setMaxQuantityLoading(true);
    const inventorySearchLink = masterAPI["inventory"].search;
    await axiosPrivate
      .post(`${inventorySearchLink}`, payload)
      .then((res) => {
        const result = res.data?.result || [];
        // Pick the on-hand field matching the deepest selected location level
        let qtyField = "balanceQuantity";
        if (binId) qtyField = "quantityOnHandInBin";
        else if (rowId) qtyField = "quantityOnHandInRow";
        else if (aisleId) qtyField = "quantityOnHandInAisle";
        else if (stockRoomId) qtyField = "quantityOnHandInRoom";
        const totalQty = result.reduce(
          (sum, r) => sum + (Number(r[qtyField]) || 0),
          0,
        );
        const avgPrice = result[0]?.averagePrice || 0;
        setMaxQuantity(result.length ? totalQty : "");
        setIssueItem((prev) => ({
          ...prev,
          unitCost: avgPrice,
          lineCost: Number(prev.quantity) * avgPrice,
        }));
      })
      .catch((e) => {
        console.log(e, "inventory search error");
        setMaxQuantity("");
        setIssueItem((prev) => ({ ...prev, unitCost: 0, lineCost: 0 }));
      })
      .finally(() => {
        setMaxQuantityLoading(false);
      });
  };

  const handleStockRoom = async (value) => {
    const getAisleLink = masterAPI["selectList"].aisleByPartAndRoom;
    await axiosPrivate
      .get(`${getAisleLink}/${issueItem.partId}/${value.value}/true`)
      .then((res) => {
        const storeStockRoom = {
          ...issueItem,
          stockRoomId: value.value,
          stockRoomName: value.text,
          stockRoomRowAisleId: null,
          stockRoomRowId: null,
          stockRoomRowBinId: null,
        };
        setIssueItem(storeStockRoom);
        setStockAisleOptions(res.data);
        setStockRowOptions([]);
        setStockBinOptions([]);
      })
      .catch((e) => {
        console.log(e, "error");
      });
    // Update Max Quantity + unit price for the selected stock room
    fetchInventoryMax({
      partId: issueItem.partId,
      stockRoomId: value.value,
      stockRoomRowAisleId: null,
      stockRoomRowId: null,
      stockRoomRowBinId: null,
    });
  };
  const handleStockAisle = async (value) => {
    const getRowLink = masterAPI["selectList"].rowByPartAndAisle;
    await axiosPrivate
      .get(`${getRowLink}/${issueItem.partId}/${value.value}/true`)
      .then((res) => {
        const storeStockRoom = {
          ...issueItem,
          stockRoomRowAisleId: value.value,
          aisleName: value.text,
          stockRoomRowId: null,
          stockRoomRowBinId: null,
        };
        setIssueItem(storeStockRoom);
        setStockRowOptions(res.data);
        setStockBinOptions([]);
      })
      .catch((e) => {
        console.log(e, "error");
      });
    // Update Max Quantity for the selected aisle
    fetchInventoryMax({
      partId: issueItem.partId,
      stockRoomId: issueItem.stockRoomId,
      stockRoomRowAisleId: value.value,
      stockRoomRowId: null,
      stockRoomRowBinId: null,
    });
  };
  const handleStockRow = async (value) => {
    const getBinLink = masterAPI["selectList"].binByPartAndRow;
    await axiosPrivate
      .get(`${getBinLink}/${issueItem.partId}/${value.value}/true`)
      .then((res) => {
        const storeStockRoom = {
          ...issueItem,
          stockRoomRowId: value.value,
          rowName: value.text,
          stockRoomRowBinId: null,
        };
        setIssueItem(storeStockRoom);
        setStockBinOptions(res.data);
      })
      .catch((e) => {
        console.log(e, "error");
      });
    // Update Max Quantity for the selected row
    fetchInventoryMax({
      partId: issueItem.partId,
      stockRoomId: issueItem.stockRoomId,
      stockRoomRowAisleId: issueItem.stockRoomRowAisleId,
      stockRoomRowId: value.value,
      stockRoomRowBinId: null,
    });
  };
  const handleStockBin = (value) => {
    const storeStockRoom = {
      ...issueItem,
      stockRoomRowBinId: value.value,

      binName: value.text,
    };

    setIssueItem(storeStockRoom);
    // Update Max Quantity for the selected bin
    fetchInventoryMax({
      partId: issueItem.partId,
      stockRoomId: issueItem.stockRoomId,
      stockRoomRowAisleId: issueItem.stockRoomRowAisleId,
      stockRoomRowId: issueItem.stockRoomRowId,
      stockRoomRowBinId: value.value,
    });
  };

  // Clearing a location field also clears its dependent (lower) fields
  const handleClearStockRoom = () => {
    setIssueItem((prev) => ({
      ...prev,
      stockRoomId: null,
      stockRoomName: "",
      stockRoomRowAisleId: null,
      stockRoomRowId: null,
      stockRoomRowBinId: null,
    }));
    setStockAisleOptions([]);
    setStockRowOptions([]);
    setStockBinOptions([]);
    setMaxQuantity("");
  };

  const handleClearAisle = () => {
    setIssueItem((prev) => ({
      ...prev,
      stockRoomRowAisleId: null,
      stockRoomRowId: null,
      stockRoomRowBinId: null,
    }));
    setStockRowOptions([]);
    setStockBinOptions([]);
    // Recompute Max at the stock-room level
    fetchInventoryMax({
      partId: issueItem.partId,
      stockRoomId: issueItem.stockRoomId,
      stockRoomRowAisleId: null,
      stockRoomRowId: null,
      stockRoomRowBinId: null,
    });
  };

  const handleClearRow = () => {
    setIssueItem((prev) => ({
      ...prev,
      stockRoomRowId: null,
      stockRoomRowBinId: null,
    }));
    setStockBinOptions([]);
    // Recompute Max at the aisle level
    fetchInventoryMax({
      partId: issueItem.partId,
      stockRoomId: issueItem.stockRoomId,
      stockRoomRowAisleId: issueItem.stockRoomRowAisleId,
      stockRoomRowId: null,
      stockRoomRowBinId: null,
    });
  };

  const handleClearBin = () => {
    setIssueItem((prev) => ({
      ...prev,
      stockRoomRowBinId: null,
    }));
    // Recompute Max at the row level
    fetchInventoryMax({
      partId: issueItem.partId,
      stockRoomId: issueItem.stockRoomId,
      stockRoomRowAisleId: issueItem.stockRoomRowAisleId,
      stockRoomRowId: issueItem.stockRoomRowId,
      stockRoomRowBinId: null,
    });
  };

  const handleIssueList = () => {
    if (issueItem.quantity === 0) {
      toast.warn("Quantity must be greater than 0");
      return;
    } else {
      const addlist = [
        ...addIssue,
        {
          ...issueItem,
          assignType: partAssignType,
          issuedDate: toUTC(issueItem.issuedDate).utcISOString,
        },
      ];
      console.log(addlist);
      setAddIssue(addlist);
      setIssueItem({
        partId: null,
        stockRoomId: null,
        stockRoomRowId: null,
        stockRoomRowAisleId: null,
        stockRoomRowBinId: null,
        quantity: 0,
        unitCost: 0,
        lineCost: 0,
        issuedDate: getCurrentInTimeZone().dayjsObject,
      });
      setStockRoomOptions([]);
      setStockAisleOptions([]);
      setStockRowOptions([]);
      setStockBinOptions([]);
      setMaxQuantity("");
      setReservedQuantity("");
    }
  };

  const handlePartEdit = async (data) => {
    console.log(data.row);
    const filterAddIssue = addIssue.filter(
      (fil, i) => i !== Number(data.row.id),
    );
    const item = data.row.original;
    const partId = item.partId;

    let updatedItem = {
      ...item,
      code: item.code || item.partCode || "",
      issuedDate: item.issuedDate
        ? fromUTC(item.issuedDate).dayjsObject
        : getCurrentInTimeZone().dayjsObject,
    };

    // Fetch stock rooms for this part
    if (partId) {
      const srLink = masterAPI["selectList"].stockRoomByPart;
      await axiosPrivate
        .get(`${srLink}/${partId}/true`)
        .then((res) => {
          setStockRoomOptions(res.data);
        })
        .catch((e) => {
          console.log(e, "error fetching stock rooms");
          setStockRoomOptions([]);
        });
    } else {
      setStockRoomOptions([]);
    }

    // Fetch aisles for this part + stock room
    if (partId && item.stockRoomId) {
      const getAisleLink = masterAPI["selectList"].aisleByPartAndRoom;
      await axiosPrivate
        .get(`${getAisleLink}/${partId}/${item.stockRoomId}/true`)
        .then((res) => {
          setStockAisleOptions(res.data);
        })
        .catch((e) => {
          console.log(e, "error fetching aisles");
          setStockAisleOptions([]);
        });
    } else {
      setStockAisleOptions([]);
    }

    // Fetch rows for this part + aisle
    if (partId && item.stockRoomRowAisleId) {
      const getRowLink = masterAPI["selectList"].rowByPartAndAisle;
      await axiosPrivate
        .get(`${getRowLink}/${partId}/${item.stockRoomRowAisleId}/true`)
        .then((res) => {
          setStockRowOptions(res.data);
        })
        .catch((e) => {
          console.log(e, "error fetching rows");
          setStockRowOptions([]);
        });
    } else {
      setStockRowOptions([]);
    }

    // Fetch bins for this part + row
    if (partId && item.stockRoomRowId) {
      const getBinLink = masterAPI["selectList"].binByPartAndRow;
      await axiosPrivate
        .get(`${getBinLink}/${partId}/${item.stockRoomRowId}/true`)
        .then((res) => {
          setStockBinOptions(res.data);
        })
        .catch((e) => {
          console.log(e, "error fetching bins");
          setStockBinOptions([]);
        });
    } else {
      setStockBinOptions([]);
    }

    setPartAssignType(item.assignType || "Unassigned");
    setIssueItem(updatedItem);
    setAddIssue(filterAddIssue);

    if (item.assignType === "Reserved") {
      const matchedReservation = reservedParts.find(
        (r) => r.id === item.partsReservationId,
      );
      setReservedQuantity(matchedReservation ? matchedReservation.quantity : "");
    } else {
      setReservedQuantity("");
    }

    // Recompute Max Quantity (and current unit cost) for this item's location
    fetchInventoryMax({
      partId: item.partId,
      stockRoomId: item.stockRoomId,
      stockRoomRowAisleId: item.stockRoomRowAisleId,
      stockRoomRowId: item.stockRoomRowId,
      stockRoomRowBinId: item.stockRoomRowBinId,
    });
  };

  const partColumn = [
    {
      Header: "Part",
      accessor: "code",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              color: "#0d6efd",
              fontSize: "inherit",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {cell.value + " - " + cell.row.original.partName}
          </Typography>
        );
      },
    },
    {
      Header: "Stock Name",
      accessor: "stockRoomName",
    },
    {
      Header: "Aisle",
      accessor: "aisleName",
    },
    {
      Header: "Row",
      accessor: "rowName",
    },
    {
      Header: "Bin",
      accessor: "binName",
    },
    {
      Header: "Quantity",
      accessor: "quantity",
    },
    {
      Header: "Unit Cost",
      accessor: "unitCost",
      Cell: ({ cell }) => (
        <>
          {siteInfoDetail.currencySymbol}
          {cell.value}
        </>
      ),
    },
    {
      Header: "Line Cost",
      accessor: "lineCost",
      Cell: ({ cell }) => (
        <>
          {siteInfoDetail.currencySymbol}
          {cell.value != null ? parseFloat(Number(cell.value).toFixed(2)) : ""}
        </>
      ),
    },
    {
      Header: "Issued Date",
      accessor: "issuedDate",
    },
    {
      Header: "Assign Type",
      accessor: "assignType",
    },

    {
      Header: "Action",
      accessor: "partId",
      Cell: ({ cell }) => {
        return (
          <>
            <IconButton>
              <EditOutlined
                onClick={() => {
                  handlePartEdit(cell);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
            <IconButton
              onClick={() => {
                deleteIssue(cell.row.original.partId);
              }}
            >
              <DeleteOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
          </>
        );
      },
      disableFilters: true,
    },
  ];

  const deleteIssue = (id) => {
    const delIssue = addIssue.filter((fil) => fil.partId !== id);
    setAddIssue(delIssue);
  };

  const getCurrentPartOptions = () => {
    switch (partAssignType) {
      case "Assigned":
        return workOrderParts;
      case "Reserved":
        return reservedParts;
      case "Unassigned":
      default:
        return partData;
    }
  };

  const getCurrentPartValue = () => {
    const options = getCurrentPartOptions();
    switch (partAssignType) {
      case "Assigned":
        return (
          options.find((o) => o.id === issueItem.workOrderPartsId) || null
        );
      case "Reserved":
        return (
          options.find((o) => o.id === issueItem.partsReservationId) || null
        );
      case "Unassigned":
      default:
        return options.find((o) => o.partId === issueItem.partId) || null;
    }
  };

  const getPartOptionLabel = (option) => {
    if (partAssignType === "Reserved") {
      return (
        (option.partCode ? option.partCode + " - " : "") + option.partName ||
        option
      );
    } else {
      return option.code + " - " + option.partName || option;
    }
  };

  const handlePartSelection = (value) => {
    if (value !== null) {
      switch (partAssignType) {
        case "Assigned":
          handleAssignedPart(value);
          break;
        case "Reserved":
          setReservedQuantity(value.quantity);
          handleReservedPart(value);
          break;
        case "Unassigned":
        default:
          handlePart(value);
          break;
      }
    } else {
      setIssueItem({
        ...issueItem,
        partId: null,
        stockRoomId: null,
        stockRoomName: "",
        stockRoomRowAisleId: null,
        stockRoomRowId: null,
        stockRoomRowBinId: null,
        stockRoom: [],
      });
      setStockRoomOptions([]);
      setStockAisleOptions([]);
      setStockRowOptions([]);
      setStockBinOptions([]);
      setMaxQuantity("");
      setReservedQuantity("");
    }
  };

  // Disable the add (+) icon while the entered quantity is invalid
  // (over available Max, or over the Reserved quantity for the Reserved type)
  const isQuantityInvalid =
    (maxQuantity !== "" &&
      Number(issueItem.quantity) > Number(maxQuantity)) ||
    (partAssignType === "Reserved" &&
      reservedQuantity !== "" &&
      Number(issueItem.quantity) > Number(reservedQuantity));

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit" ? "Edit Issue" : "New Issue"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ setFieldValue, values }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Work Order
                </Typography>
                <Autocomplete
                  value={selectedWorkOrder}
                  fullWidth
                  filterOptions={filterOptions}
                  loading={woData.length === 0}
                  options={woData}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    option.code + " - " + option.workOrderName || option
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  readOnly={mode === "Edit"}
                  onChange={(event, value) => {
                    if (mode === "Edit") return;
                    handleWorkOrderChange(event, value, setFieldValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="workOrderId"
                      placeholder="Select Wo"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        readOnly: mode === "Edit",
                        endAdornment:
                          mode === "Edit" ? null : (
                            <React.Fragment>
                              {woData.length === 0 ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                      }}
                      sx={{
                        ".MuiInputBase-root": {
                          backgroundColor:
                            mode === "Edit" ? "#F5F5F5" : "inherit",
                        },
                        ".MuiInputBase-input": {
                          color: mode === "Edit" ? "#555555" : "inherit",
                        },
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Asset
                </Typography>
                <Autocomplete
                  value={
                    assetData.find((a) => a.id === values.assetId) || null
                  }
                  fullWidth
                  filterOptions={filterOptions}
                  loading={assetData.length === 0}
                  options={assetData}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    option.code + " - " + option.assetName || option
                  }
                  readOnly={mode === "Edit"}
                  onChange={(event, value) => {
                    if (mode === "Edit") return;
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("assetId", value.id);
                    } else {
                      setFieldValue("assetId", null);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="assetId"
                      placeholder="Select Asset"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        readOnly: mode === "Edit",
                        endAdornment:
                          mode === "Edit" ? null : (
                            <React.Fragment>
                              {assetData.length === 0 ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                      }}
                      sx={{
                        ".MuiInputBase-root": {
                          backgroundColor:
                            mode === "Edit" ? "#F5F5F5" : "inherit",
                        },
                        ".MuiInputBase-input": {
                          color: mode === "Edit" ? "#555555" : "inherit",
                        },
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Transaction Date
                </Typography>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      readOnly
                      format="DD/MM/YYYY hh:mm:ss A"
                      value={
                        values.issuedDate === null
                          ? null
                          : dayjs(values.issuedDate)
                      }
                      slotProps={{
                        textField: {
                          size: "small",

                          fullWidth: true,
                        },
                      }}
                      fullWidth
                      onChange={(newValue) => {
                        console.log(newValue);
                        if (newValue !== null) {
                          if (`${newValue.$d}` !== "Invalid Date") {
                            const dateFrom = getDateWithOutUTC(newValue);
                            setFieldValue("issuedDate", dateFrom);
                          }
                        }
                      }}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Gl Credit Account
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="glCreditAccount"
                  placeholder="Enter GL Credit Account"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Gl Debit Account
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="glDebitAccount"
                  placeholder="Enter GL Debit Account"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Issued To
                </Typography>
                <Autocomplete
                  value={
                    personData.find((p) => p.id === values.issuedToPersonId) ||
                    null
                  }
                  fullWidth
                  filterOptions={filterOptions}
                  loading={personData.length === 0}
                  options={personData}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.personName || option}
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("issuedToPersonId", value.id);
                    } else {
                      setFieldValue("issuedToPersonId", null);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="returnedById"
                      placeholder="Select Person"
                      //  onChange={handleChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {personData.length === 0 ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      color: color.masterDialogTitleColor,
                      fontSize: color.masterDialogFontSize,
                    }}
                  >
                    Create Issued Item
                  </Typography>
                  <IconButton
                    disabled={isQuantityInvalid}
                    sx={{
                      backgroundColor: isQuantityInvalid
                        ? "#cccccc"
                        : color.TableButtonColor,
                      "&.Mui-disabled": {
                        backgroundColor: "#cccccc",
                      },
                    }}
                    onClick={handleIssueList}
                  >
                    <Add sx={{ color: "white" }} />
                  </IconButton>
                </Box>
                <Divider
                  sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                />
              </Grid>

              <Grid container item xs={12} spacing={"1rem"}>
                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Part Assign Type
                  </Typography>
                  <Select
                    size={"small"}
                    type="text"
                    name="partAssignType"
                    value={partAssignType}
                    fullWidth
                    onChange={handlePartAssignTypeChange}
                  >
                    <MenuItem value="Unassigned">Unassigned</MenuItem>
                    {/* <MenuItem value="Assigned">Assigned</MenuItem> */}
                    <MenuItem value="Reserved">Reserved</MenuItem>
                  </Select>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Part
                  </Typography>
                  <Autocomplete
                    value={getCurrentPartValue()}
                    fullWidth
                    filterOptions={filterOptions}
                    loading={
                      loadingParts &&
                      (partAssignType === "Assigned" ||
                        partAssignType === "Reserved")
                    }
                    options={getCurrentPartOptions()}
                    PaperComponent={CustomPaper}
                    getOptionLabel={getPartOptionLabel}
                    disabled={
                      (partAssignType === "Assigned" ||
                        partAssignType === "Reserved") &&
                      !selectedWorkOrder
                    }
                    onChange={(event, value) => {
                      handlePartSelection(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="partId"
                        placeholder={
                          (partAssignType === "Assigned" ||
                            partAssignType === "Reserved") &&
                          !selectedWorkOrder
                            ? "Select Work Order First"
                            : "Select Part"
                        }
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loadingParts &&
                              (partAssignType === "Assigned" ||
                                partAssignType === "Reserved") ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Stock Room
                  </Typography>
                  <Autocomplete
                    value={
                      stockRoomOptions.find(
                        (s) => s.value === issueItem.stockRoomId,
                      ) || null
                    }
                    fullWidth
                    filterOptions={filterOptions}
                    options={stockRoomOptions}
                    PaperComponent={CustomPaper}
                    getOptionLabel={(option) => option.text || option}
                    disabled={partAssignType === "Reserved"}
                    onChange={(event, value) => {
                      console.log(value);
                      if (value !== null) {
                        handleStockRoom(value);
                      } else {
                        handleClearStockRoom();
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="stockRoomId"
                        placeholder={
                          partAssignType === "Reserved"
                            ? "Auto-Selected (Reserved)"
                            : "Select Stock Room"
                        }
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Aisle
                  </Typography>
                  <Autocomplete
                    value={
                      stockAisleOptions.find(
                        (a) => a.value === issueItem.stockRoomRowAisleId,
                      ) || null
                    }
                    fullWidth
                    filterOptions={filterOptions}
                    options={stockAisleOptions}
                    PaperComponent={CustomPaper}
                    getOptionLabel={(option) => option.text || option}
                    onChange={(event, value) => {
                      console.log(value);
                      if (value !== null) {
                        handleStockAisle(value);
                      } else {
                        handleClearAisle();
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="stockRoomRowAisleId"
                        placeholder="Select Aisle"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Row
                  </Typography>
                  <Autocomplete
                    value={
                      stockRowOptions.find(
                        (r) => r.value === issueItem.stockRoomRowId,
                      ) || null
                    }
                    fullWidth
                    filterOptions={filterOptions}
                    options={stockRowOptions}
                    PaperComponent={CustomPaper}
                    getOptionLabel={(option) => option.text || option}
                    onChange={(event, value) => {
                      console.log(value);
                      if (value !== null) {
                        handleStockRow(value);
                      } else {
                        handleClearRow();
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="stockRoomRowId"
                        placeholder="Select Row"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Bin
                  </Typography>
                  <Autocomplete
                    value={
                      stockBinOptions.find(
                        (b) => b.value === issueItem.stockRoomRowBinId,
                      ) || null
                    }
                    fullWidth
                    filterOptions={filterOptions}
                    options={stockBinOptions}
                    PaperComponent={CustomPaper}
                    getOptionLabel={(option) => option.text || option}
                    onChange={(event, value) => {
                      console.log(value);
                      if (value !== null) {
                        handleStockBin(value);
                      } else {
                        handleClearBin();
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="stockRoomRowBinId"
                        placeholder="Select Bin"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Quantity
                  </Typography>
                  <TextField
                    size={"small"}
                    type="number"
                    name="quantity"
                    value={issueItem.quantity}
                    placeholder="Enter Quantity"
                    fullWidth
                    onChange={handleAddIssue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {maxQuantityLoading ? (
                            <CircularProgress color="inherit" size={16} />
                          ) : (
                            [
                              maxQuantity !== ""
                                ? `Max: ${maxQuantity}`
                                : null,
                              partAssignType === "Reserved" &&
                              reservedQuantity !== ""
                                ? `Reserved: ${reservedQuantity}`
                                : null,
                            ]
                              .filter(Boolean)
                              .join(" | ")
                          )}
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      ".MuiInputBase-input": {
                        "&::placeholder": {
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Unit Cost
                  </Typography>
                  <TextField
                    size={"small"}
                    type="number"
                    name="unitCost"
                    value={issueItem.unitCost}
                    placeholder="Unit Cost"
                    fullWidth
                    InputProps={{ readOnly: true }}
                    sx={{
                      ".MuiInputBase-root": {
                        backgroundColor: "#F5F5F5",
                      },
                      ".MuiInputBase-input": {
                        color: "#555555",
                        "&::placeholder": {
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Line Cost
                  </Typography>
                  <TextField
                    size={"small"}
                    type="number"
                    name="lineCost"
                    value={issueItem.lineCost != null ? parseFloat(Number(issueItem.lineCost).toFixed(2)) : ""}
                    placeholder="Line Cost"
                    fullWidth
                    InputProps={{ readOnly: true }}
                    sx={{
                      ".MuiInputBase-root": {
                        backgroundColor: "#F5F5F5",
                      },
                      ".MuiInputBase-input": {
                        color: "#555555",
                        "&::placeholder": {
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Issued Date
                  </Typography>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoItem>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={
                          issueItem.issuedDate === null
                            ? null
                            : dayjs(issueItem.issuedDate)
                        }
                        slotProps={{
                          textField: {
                            size: "small",

                            fullWidth: true,
                          },
                        }}
                        fullWidth
                        onChange={(newValue) => {
                          console.log(newValue);
                          if (newValue !== null) {
                            if (`${newValue.$d}` !== "Invalid Date") {
                              const dateFrom = getDateWithOutUTC(newValue);
                              const storeDate = {
                                ...issueItem,
                                issuedDate: dateFrom,
                              };
                              setIssueItem(storeDate);
                            }
                          }
                        }}
                      />
                    </DemoItem>
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      color: color.masterDialogTitleColor,
                      fontSize: color.masterDialogFontSize,
                    }}
                  >
                    Issue Item List
                  </Typography>
                </Box>
                <Divider
                  sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                />
              </Grid>
              <Grid item xs={12}>
                <NormalTable data={addIssue} columns={partColumn} filt={true} />
              </Grid>
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={
                    loading || (mode === "Create" && addIssue.length === 0)
                  }
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default IssueModal;
